<template>
    <div :class="[
        'formbox-sampling',
        { 'is-open': isOpen }
    ]">
        <div class="wrapper">
            <form 
                class="bg-color-secondary"
                @submit.prevent="onSubmit"
            >
                <Validatable ref="validatable">
                    <InputNumberMultiple
                        v-model="cardNumber"
                        :items-lengths="[3, 6, 3]"
                        :is-required="true"
                        label="Wpisz numer swojej karty MAKRO"
                        theme="compact"
                    />
                    <InputTextMultiple 
                        v-model="name"
                        :items="['Imię', 'Nazwisko']" 
                        :is-required="isNameRequired"
                        :class="{ 'is-hidden': !isNameRequired }"
                    />
                    <div class="formbox-sampling-bottom flex">
                        <p 
                            v-bastards 
                            class="fs-16"
                        >
                            Wyślemy Ci informację na email, jak odebrać wybrany produkt.
                        </p>
                        <button
                            type="submit"
                            class="button-primary btn btn-c--primary text-color-contrast fs-17 text-upper"
                            v-text="`Zapisz`"
                        />
                    </div>
                </Validatable>
            </form>
        </div>
    </div>
</template>

<script>
// import ButtonPrimary from '@/components/button/ButtonPrimary'
import InputNumberMultiple from '@/components/form/InputNumberMultiple'
import VueScrollTo from 'vue-scrollto'
import { isOldCardNumber } from '@/helpers'

export default {
    components: {
        //ButtonPrimary,
        InputNumberMultiple
    },

    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        selectedSampleId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            cardNumber: [],
            name: [],
            isNameRequired: false
        }
    },

    computed: {
        payload() {
            return {
                sample: this.selectedSampleId,
                partCard1: this.cardNumber[0] || '',
                partCard2: this.cardNumber[1] || '',
                partCard3: this.cardNumber[2] || '',
                firstName: this.name[0] || '',
                lastName: this.name[1] || ''
            }
        }
    },

    watch: {
        cardNumber: {
            handler: function(value) {
                if (isOldCardNumber(value)) {
                    this.isNameRequired = true
                }
                else {
                    this.isNameRequired = false
                }
            },
            deep: true
        },

        isOpen(snapshot) {
            if (snapshot === true) {
                // @TODO: this is not so clever; what if we have more than one FormboxSampling component in a container (although not likely)?
                VueScrollTo.scrollTo('.formbox-sampling', 1500) 
            }
        }
    },

    methods: {
        onSubmit() {
            if (!this.$refs.validatable.validate()) {
                return
            }

            this.$emit('submit', this.payload)
        }
    }
}
</script>

<style lang="scss">
.formbox-sampling {
    @include transform(translateY(-10px));
    @include transition(opacity .200s, transform .200s);
    overflow: hidden;
    max-height: 0;
    padding: 0;
    opacity: 0;

    &-bottom {
        padding: 0 0 0 0;

        > p {
            padding-right: 15px;
        }

        .button-primary {
            padding: 13px 50px;
        }
    }

    &.is-open {
        @include transform-none();
        max-height: none;
        max-height: unset;
        padding: 50px 0 35px;
        opacity: 1;
    }

    form {
        margin: 0 auto;
        padding: 33px 42px 15px;
        max-width: 730px;
        min-height: 164px;

        .input-text-multiple {
            padding-bottom: 20px;
            max-width: 63%;
            margin-left: 37%;
            opacity: 1;

            &.is-hidden {
                @include transition(max-height .150s, opacity .150s);
                max-height: 0;
                overflow: hidden;
                padding: 0;
                opacity: 0;
            }
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        form {
            padding: 25px 25px 30px;
            margin-left: -25px;
            margin-right: -25px;
        }

        &-bottom {
            display: block;
            text-align: center;

            > p {
                padding-right: 0;
                padding-top: 15px;
                padding-bottom: 15px;
            }
        }

        .input-number-multiple {
            display: block;

            label,
            &-inputs {
                max-width: 100%;
                padding-right: 0;
                padding-bottom: 5px;
                margin-right: 0;
            }
        }
    }
}
</style>
